import React from 'react';
import PropTypes from 'prop-types';

import { colors } from '../../../common/styles/style-constants';

const Noon = ({ color }) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="24"
    height="24"
  >
    <path
      fill={color}
      d="M200 112.5a87.5 87.5 0 1 0 87.5 87.5 87.5 87.5 0 0 0-87.5-87.5zm0 150a62.5 62.5 0 1 1 62.5-62.5 62.5 62.5 0 0 1-62.5 62.5zM212.63 88.21V50a12.63 12.63 0 1 0-25.25 0v38.21a112.73 112.73 0 0 1 25.25 0zM187.37 311.79V350a12.63 12.63 0 0 0 25.25 0v-38.21a112.73 112.73 0 0 1-25.25 0zM88.21 187.37H50a12.63 12.63 0 0 0 0 25.25h38.21a112.74 112.74 0 0 1 0-25.25zM350 187.37h-38.21a112.74 112.74 0 0 1 0 25.25H350a12.63 12.63 0 0 0 0-25.25zM112 270.12l-27 27A12.63 12.63 0 0 0 102.86 315l27-27A113.17 113.17 0 0 1 112 270.12zM288 129.88l27-27A12.63 12.63 0 0 0 297.14 85l-27 27A113.17 113.17 0 0 1 288 129.88zM129.88 112l-27-27A12.63 12.63 0 0 0 85 102.86l27 27A113.16 113.16 0 0 1 129.88 112zM270.12 288l27 27A12.63 12.63 0 1 0 315 297.14l-27-27A113.16 113.16 0 0 1 270.12 288z"
    />
  </svg>
);

Noon.defaultProps = {
  color: colors.blue,
};

Noon.propTypes = {
  color: PropTypes.string,
};

export default Noon;
